import PlusIcon from '@/assets/icons/icon-plus.svg'
import { Button } from '@/components/ui/button.tsx'

interface Props {
  onClickCreate: () => void
}

export const HeaderButtons = ({ onClickCreate }: Props) => {
  return (
    <div className="flex items-center gap-2">
      <Button
        onClick={onClickCreate}
        className="flex gap-1"
      >
        <PlusIcon
          width={25}
          height={25}
        />
        Create
      </Button>
    </div>
  )
}
